import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Lock } from 'lucide-react';
import { usePremium } from '../Subscription/PremiumProvider';
import { isLocked } from '../../lib/premiumLock';
import { highlightMatch } from './highlightMatch';
import TopicInspectPanel from './TopicInspectPanel';

/**
 * Expanded basketless (standalone) topic — inspect panel only, no hub.
 */
const ConnectionsExpandedStandaloneCard = ({
  item,
  searchTerm = '',
  onCollapse,
  liveTopic,
  onAddToBasket,
  onMoveToBasket,
  onTopicDeleted,
  onBeforeLeave,
}) => {
  const { isPremium, isLoading } = usePremium();
  const topic = liveTopic || item.topic;
  const showLock = isLocked(topic || item, isPremium, isLoading);
  const recencyLabel = item.updatedAt
    ? formatDistanceToNow(new Date(item.updatedAt), { addSuffix: true })
    : null;

  return (
    <div className="border-2 border-neutral-200 rounded-xl bg-white overflow-hidden">
      <button
        type="button"
        onClick={onCollapse}
        className="w-full text-left px-4 py-3 border-b border-neutral-200 hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cranberry-700"
        aria-label={`Collapse ${topic?.name || item.name}${showLock ? ' (Premium)' : ''}`}
      >
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="flex items-center gap-2 min-w-0">
              <p className="font-semibold text-neutral-900 truncate min-w-0">
                {highlightMatch(topic?.name || item.name, searchTerm)}
              </p>
              {showLock && (
                <Lock
                  size={14}
                  className="text-neutral-400 shrink-0"
                  aria-hidden="true"
                />
              )}
            </div>
            <p className="text-sm text-neutral-500 mt-0.5">
              {topic?.basket_id
                ? topic?.basket?.name
                  ? `in ${topic.basket.name}`
                  : 'in a basket'
                : 'no basket'}
              {recencyLabel ? ` · ${recencyLabel}` : ''}
            </p>
          </div>
          <span className="text-xs text-neutral-400 flex-shrink-0 mt-1">Collapse</span>
        </div>
      </button>

      <div className="flex min-h-[280px] flex-col">
        <TopicInspectPanel
          topic={topic}
          onAddToBasket={onAddToBasket}
          onMoveToBasket={onMoveToBasket}
          onDeleted={onTopicDeleted}
          onBeforeLeave={onBeforeLeave}
        />
      </div>
    </div>
  );
};

export default ConnectionsExpandedStandaloneCard;
